<template>
  <v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="primary--text pb-2">Status</h2>
        <p>Add or remove case status options. The top option is the default status used when creating a new case. You can re-order status’ by dragging and dropping.</p>
      </v-flex>
      <v-flex xs12>
        <draggable
          style="width: 100%; min-height: 10px;"
          v-model="statuses"
          :ghost="true"
        >
          <SortableItem
            v-for="(status, index) in statuses"
            :index="index"
            :position="index"
            :key="status.id"
            :item="status"
            class="mb-1"
            v-on:status-remove="removeStatus(status)"/>
        </draggable>
        <form class="pt-3">
          <v-layout wrap row>
            <v-flex xs12 md6>
              <v-text-field
                v-model="newStatusName"
                @keydown.native.enter.prevent="createStatus()"
                label="New status name"
                box
              ></v-text-field>
            </v-flex>
            <v-flex xs12 style="margin-top:-12px">
              <v-btn class="ml-0 mt-0" color="secondary" @click="createStatus()">Add new status</v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import DeleteDialog from "@/components/shared/deleteDialog"
import draggable from "vuedraggable"

const SortableItem = {
  components: { DeleteDialog },
  props: ["item", "position"],
  template: `
    <v-list-tile class="drag-drop-list-item state ml-0 mb-2 pb-1 rounded-3 elevation-2 ">
    <v-layout wrap row xs12>
      <v-icon color="secondary" class="mt-1">swap_vert</v-icon>
      <v-list-tile-content class="ma-0 pa-0">
        <div v-if="!editable" style="position:relative; width:100%;">
          <h3 class="ml-2 mt-3 pt-1 text-truncate" style="padding-right:120px">
            {{data.state}}
          </h3>                    
        </div>
        <v-layout xs12 v-if="editable" align-center>
          <v-text-field class="white-box-field pl-3"  solo flat v-model="data.state" style="margin-top:31px">
          </v-text-field>
          <v-btn class="mr-0" v-on:click="update()" icon>
            <v-icon color="success">done</v-icon>
          </v-btn>
          <v-btn class="ml-0" v-on:click="cancel()" icon>
            <v-icon color="error">clear</v-icon>
          </v-btn>
        </v-layout>
      </v-list-tile-content>
      <v-flex shrink mr-2 mt-1>
       <v-tooltip left color="secondary" v-if="!editable">
          <v-btn slot="activator" class="mr-4" icon>
        <v-icon class="edit" small @click="editable = true"></v-icon>
      </v-btn>
      <span>Edit Status name</span>
      </v-tooltip>
      </v-flex>
      <v-btn style="position:absolute; z-index:9; right:3px; top:2px" icon @click="deleteDialog = true">
        <v-icon color="error">cancel</v-icon>
      </v-btn>
      <delete-dialog :isOpen="deleteDialog" itemType="state" v-on:delete-item="remove"></delete-dialog>
      </v-layout>
    </v-list-tile>
  `,
  data() {
    return {
      editable: false,
      deleteDialog: false
    }
  },
  computed: {
    data() {
      if (this.item) { return this.item }
    }
  },
  watch: {
    position() {
      this.data.position = this.position
      this.$store.dispatch("updateCaseState", { stateId: this.data.id, state: this.data.state, position: this.data.position })
    }
  },
  methods: {
    remove(shouldDelete) {
      this.editable = false
      this.deleteDialog = false
      if (shouldDelete) {
        this.$emit("status-remove")
      }
    },
    async update() {
      this.editable = false
      const pos = this.data.position ? this.data.position : this.position
      this.$store.dispatch("updateCaseState", {
        stateId: this.data.id,
        state: this.data.state,
        position: pos
      })
    },
    cancel() {
      this.editable = false
      this.data = this.item
    }
  }
}

export default {
  name: "case-config-status",
  data: () => {
    return {
      statusTitle: true,
      statusTitleEdit: false,
      newStatusName: "",
      statuses: []
    }
  },
  props: { caseType: { type: Object, required: true } },
  components: { SortableItem, draggable },
  watch: {
    caseType() { this.statuses = this.orderStatuses() }
  },
  created() {
    if (this.caseType && this.caseType.statuses) {
      this.statuses = this.orderStatuses()
    }
  },
  methods: {
    orderStatuses() {
      if (this.caseType && this.caseType.statuses) {
        return this.caseType.statuses.sort(function (a, b) {
          if (a.position < b.position) { return -1 }
          if (a.position > b.position) { return 1 }
          return 0
        })
      }
    },
    async createStatus() {
      if (this.newStatusName) {
        const newState = await this.$store.dispatch("createCaseState", {
          caseTypeId: this.caseType.id,
          state: this.newStatusName,
          position: this.statuses.length
        })
        if (!newState.error) {
          this.statuses.push(newState)
          this.newStatusName = ""
        } else {
          console.error("Failed to create status! Error: " + newState.message)
        }
      }
    },
    async removeStatus(status) {
      if (status.id) {
        const response = await this.$store.dispatch("deleteCaseState", status.id)
        if (!response.error) {
          this.statuses.splice(this.statuses.indexOf(status), 1)
        }
      }
    }
  }
}
</script>

<style>

.state {
  position: relative;
  font-family: Roboto, sans-serif !important;
   background:#eeeeee !important;
}
.state:first-of-type:after {
  content: "Default";
  position: absolute;
  top: 19px;
  left: -30px;
  opacity: 1;
  text-transform: uppercase;
  background:rgb(29, 48, 62);
  padding:1px 7px;
  color:white;
  font-size:0.66em;
-webkit-border-top-left-radius: 3px;
-webkit-border-top-right-radius: 3px;
-moz-border-radius-topleft: 3px;
-moz-border-radius-topright: 3px;
border-top-left-radius: 3px;
border-top-right-radius: 3px;
  transform:rotate(270deg)

}

</style>
